// AI generated
import {
  type Editor,
  type NodeEntry,
  Path,
  type PointRef,
  type Range,
  Text,
} from 'slate'
import type { UploadEditor } from '.'

export type UploadKind = 'image' | 'video' | 'file' | 'file-block'

export type PendingUpload = {
  id: string
  title: string
  kind: UploadKind
  pointRef: PointRef
  dimensions?: { width: number; height: number }
  error?: string
}

// onChange re-renders the editor, so the placeholders get re-decorated
function setPendingUploads(
  editor: Editor & UploadEditor,
  uploads: PendingUpload[],
) {
  editor.pendingUploads = uploads
  editor.onChange()
}

export function addPendingUpload(
  editor: Editor & UploadEditor,
  upload: PendingUpload,
) {
  setPendingUploads(editor, [...editor.pendingUploads, upload])
}

export function failPendingUpload(
  editor: Editor & UploadEditor,
  id: string,
  error: string,
) {
  setPendingUploads(
    editor,
    editor.pendingUploads.map((upload) =>
      upload.id === id ? { ...upload, error } : upload,
    ),
  )
}

export function removePendingUpload(editor: Editor & UploadEditor, id: string) {
  editor.pendingUploads.find((upload) => upload.id === id)?.pointRef.unref()
  setPendingUploads(
    editor,
    editor.pendingUploads.filter((upload) => upload.id !== id),
  )
}

export function decoratePendingUploads(
  [node, path]: NodeEntry,
  uploads: PendingUpload[],
): Range[] {
  if (!Text.isText(node)) return []

  const uploadsByOffset = Map.groupBy(
    uploads.filter(
      ({ pointRef }) =>
        pointRef.current && Path.equals(pointRef.current.path, path),
    ),
    ({ pointRef }) => pointRef.current!.offset,
  )

  return Array.from(uploadsByOffset, ([offset, pendingUploads]) => ({
    anchor: { path, offset },
    focus: { path, offset },
    pendingUploads,
  }))
}
